import React from 'react';
import { View, ScrollView, StyleSheet } from 'react-native';
import Unorderedlist from 'react-native-unordered-list';
import BaseText from '../components/BaseText';
import RowView from '../components/RowView';
import { Color, CommonProperties, CommonStyles } from '../styles';
import { scale } from '../utils/scale.utils';
import { useTranslation } from 'react-i18next';
import { useComponentTKey, i18nNS } from '../i18n';
const TermsScreen = () => {
  const { t } = useTranslation(i18nNS.terms);
  const { tKey } = useComponentTKey('TermsScreen');
  return (
    <ScrollView style={styles.scrollView}>
      <View style={styles.container}>
        <BaseText style={styles.heading}>{t(tKey('Terms'))}</BaseText>
        <BaseText style={CommonStyles.mb3}>{t(tKey('AccessingThisWebsite'))}</BaseText>
        <BaseText style={styles.subHeading}>{t(tKey('UseLicense'))}</BaseText>
        <BaseText style={CommonStyles.mb3}>{t(tKey('Permission'))}</BaseText>
        <Unorderedlist>
          <BaseText>{t(tKey('Modify'))}</BaseText>
        </Unorderedlist>
        <Unorderedlist>
          <BaseText>{t(tKey('UseOfMaterail'))}</BaseText>
        </Unorderedlist>
        <Unorderedlist>
          <BaseText>{t(tKey('AttemptToDecompile'))}</BaseText>
        </Unorderedlist>
        <Unorderedlist>
          <BaseText>{t(tKey('RemoveAnyCopyright'))}</BaseText>
        </Unorderedlist>
        <Unorderedlist>
          <BaseText>{t(tKey('TransferMaterials'))}</BaseText>
        </Unorderedlist>
        <Unorderedlist>
          <BaseText>{t(tKey('TerminateLicense'))}</BaseText>
        </Unorderedlist>
        <BaseText style={styles.subHeading}>{t(tKey('Disclaimer'))}</BaseText>
        <BaseText style={CommonStyles.mb3}>{t(tKey('MaterailsProvided'))}</BaseText>
        <BaseText style={styles.subHeading}>{t(tKey('Limitations'))}</BaseText>
        <RowView>
          <BaseText style={styles.dollarStyle}>$0 </BaseText>
          <BaseText>{t(tKey('Fullfillment'))}</BaseText>
        </RowView>
        <RowView>
          <BaseText style={styles.dollarStyle}>$5 </BaseText>
          <BaseText>{t(tKey('Surcharge'))}</BaseText>
        </RowView>
        <RowView>
          <BaseText style={styles.dollarStyle}>$7 </BaseText>
          <BaseText>{t(tKey('EnterpriseService'))}</BaseText>
        </RowView>
        <RowView>
          <BaseText style={styles.dollarStyle}>$15 </BaseText>
          <BaseText>{t(tKey('Cancellation'))}.</BaseText>
        </RowView>
        <RowView>
          <BaseText style={styles.dollarStyle}>$25 </BaseText>
          <BaseText>{t(tKey('AgentAssistance'))}</BaseText>
        </RowView>
        <RowView>
          <BaseText style={styles.dollarStyle}>$35 </BaseText>
          <BaseText>{t(tKey('VIPAgentAssistance'))}</BaseText>
        </RowView>
        <BaseText style={styles.subHeading}>{t(tKey('Limitations'))}</BaseText>
        <BaseText style={CommonStyles.mb3}>{t(tKey('LiableForDamage'))}</BaseText>
        <BaseText style={styles.subHeading}>{t(tKey('RevisionErrata'))}</BaseText>
        <BaseText style={CommonStyles.mb3}>{t(tKey('TypeOfMaterial'))}</BaseText>
        <BaseText style={styles.subHeading}> {t(tKey('Links'))}</BaseText>
        <BaseText style={CommonStyles.mb3}>{t(tKey('NotReviewed'))}</BaseText>
        <BaseText style={styles.subHeading}>{t(tKey('Non-TripEasy'))}</BaseText>
        <BaseText style={CommonStyles.mb3}>{t(tKey('ContainLinks'))}</BaseText>
        <BaseText style={styles.subHeading}>{t(tKey('SiteTerms'))}</BaseText>
        <BaseText style={CommonStyles.mb3}>{t(tKey('RevisionOfTerms'))}</BaseText>
        <BaseText style={styles.subHeading}>{t(tKey('GoverningLaw'))}</BaseText>
        <BaseText style={CommonStyles.mb3}>{t(tKey('Claim'))}</BaseText>
        <BaseText style={CommonStyles.mb3}>{t(tKey('GeneralTerms'))}</BaseText>
      </View>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
    backgroundColor: '#F4F4F4',
  },
  dollarStyle: {
    minWidth: scale(36),
  },
  heading: {
    alignSelf: 'center',
    ...CommonProperties.h2,
  },
  subHeading: {
    fontWeight: 'bold',
    ...CommonProperties.h3,
    ...CommonProperties.mb3,
  },
  container: {
    backgroundColor: Color.accent,
    ...CommonProperties.p3,
    ...CommonProperties.m3,
  },
});
export default TermsScreen;
